module.exports = __webpack_public_path__ + "media/audio27.8718743b.wav";